import { render } from "./DocumentBrowserDetail.vue?vue&type=template&id=4dc056ff&scoped=true&ts=true"
import script from "./DocumentBrowserDetail.vue?vue&type=script&lang=ts"
export * from "./DocumentBrowserDetail.vue?vue&type=script&lang=ts"

import "./DocumentBrowserDetail.vue?vue&type=style&index=0&id=4dc056ff&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc056ff"]])

export default __exports__